import * as React from "react";
import { useState, useContext, createContext, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import { Definition, PredefinedField } from '../lib/types';
import { Grid ,Typography, IconButton, FormHelperText,} from '@mui/material';
import EmptySet from '../components/empty-set';
import {cloneDeep, merge } from 'lodash';
import LoadingView from '../components/loading-view';
import {filterPolicyMessages, getValueAtPath, setValueAtPathWithOpts} from '../form/helper';
import  Field  from '../components/form-def-field-fc' 
import {IconButton as ConfirmButton} from '~common/components/confirmation-button';
import Pager from '../components/query-fulfillment/query-list-pager';
import CookieManager from '~common/lib/cookie-manager';
import DefinitionFormController from './definition-form-controller';

import {DataContext, PolicyContext, DirtyContext} from "~common/form/icg-definition-data-provider";

let selectionColor = 'orange';
const useStyles = makeStyles((theme: Theme) =>
    
  createStyles({
    container: {
        width: '100%',
        paddingTop: 0,
        paddingBottom: 15
      },
      errorInstructions: {
        // padding: 15,
        paddingLeft: 15,
        fontSize: '1rem',
        color: '#f44336'
      },
      warnInstructions: {
        // padding: 15,
        paddingLeft: 15,
        fontSize: '1rem',
        color: '#ffae42'
      },
      historyInstructions: {
        padding: 15,
        fontSize: '1rem',
        color: '#1614b3'
      },
      fullScreen: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: '#fff',
        zIndex: 1000
      },
      sectionTitle: {
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      },
      gridContainerOffset: {
        marginLeft: 0,
        // width: "calc(100% - 16px)"
        width: "100%"
      },
      subSectionTitle: {
        marginTop: 15,
        paddingBottom: 0,
        paddingLeft: 15,
        // borderBottom: "1px solid black",
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Roboto,Arial,sans-serif;',
        fontSize: '1.15rem',
        fontWeight: 500,
        color: '#555',
        margin: '15px 0'
      },
      fieldArea: {
        display: 'flex',
        //flexDirection: "row-reverse",
        alignItems: 'center',
        marginTop: 0,
        paddingTop: 0,
      },
      formArea: {
        paddingLeft: 5,
        paddingRight: 5
      },
      formAreaOutdent: {
        paddingTop: 0,
        // paddingLeft: -20,
        marginLeft: 10,
        borderBottom: "1px solid #dedede",
        marginBottom: 5,
        paddingBottom: 10,
        // width: "100%"
        // marginRight: -150
        // paddingRight: -150
  
      },
      sectionArea: {
        display: 'flex',
        //flexDirection: "row-reverse",
        alignItems: 'baseline'
      },
      instructions: {
        padding: '0px 15px 32px 15px',
        fontSize: '1rem',
        // color: '#303030'
      },
      noInstructions: {
        padding: '5px 15px 15px 15px',
        fontSize: '1rem',
        // color: '#303030'
      },
      item: {
        display: 'flex',
        alignItems: 'baseline',
        padding: 15
      },
      itemOdd: {},
      itemEven: {
        backgroundColor: '#eaeaea'
      },
      itemActionBar: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 5,
        paddingLeft: 15,
        marginBottom: -15
      },
      singleItemActionBar: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: 5,
        paddingLeft: -5,
        marginBottom: -15
      }, 
      itemAdd: {
        marginTop: 20,
        padding: "6px !important",
        marginRight: "7px !important",
      },
      itemSingle: {},
      itemDelete: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.90rem',
        width: 30,
        height: 30,
        // padding: "10px !important"
      },
      successIcon: {
        color: 'green',
        fontSize: '0.9rem',
        paddingRight: 5
      },
      infoIcon: {
        color: '#005897',
        fontSize: '0.9rem',
        paddingRight: 5
      },
      warnIcon: {
        color: 'gold',
        fontSize: '0.9rem',
        paddingRight: 5
      },
      errorIcon: {
        color: '#f44336',
        fontSize: '0.9rem',
        paddingRight: 5
      },
      selectedRow: {
        border: '1px solid ' + selectionColor,
        margin: 1,
        position: 'relative',
        '&::before': {
          content: 'x',
          display: 'block',
          width: 20,
          height: 20,
          float: 'left',
          margin: '0 6px 0 0'
        }
      },
      unselectedRow: {
        border: '1px solid rgba(255,255,255,0.0)',
        margin: 1,
        position: 'relative',
        '&::before': {
          content: 'o',
          display: 'block',
          width: 20,
          height: 20,
          float: 'left',
          margin: '0 6px 0 0'
        }
      },
      unselectableRow: {
        border: '0px solid rgba(255,255,255,0.0)',
        margin: 1,
        position: 'relative'
      },
      selectionActionArea: {
        display: 'flex',
        justifyContent: 'flex-start', //'space-between' has the effect of pushing the selection count text to the right.
        textAlign: 'right',
        paddingLeft: 6,
        paddingRight: 5,
        paddingBottom: 5,
        verticalAlign: 'baseline',
        minHeight: 45,
        marginBottom: 5,
        fontSize: "0.85rem"
      },
      selectionCount: {
        display: 'inline-block',
        textAlign: 'left',
        paddingTop: 10
      },
      selectionAction: {
        display: 'inline-block',
        width: '30%'
      },
      allSelectors: {
        display: 'flex',
        color: '#333',
        textAlign: 'left',
        paddingTop: 10,
        paddingRight: 15
      },
      selectAll: {
        color: selectionColor,
        display: 'inline-block',
        cursor: 'pointer',
        padding: "0px 0px 0px 0px"
      },
      unselectAll: {
        color: selectionColor,
        display: 'inline-block',
        cursor: 'pointer',
        padding: "0px 30px"
      },
      selector: {
        color: selectionColor
      },
      select: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 30,
        height: 30,
        zIndex: 20,
        color: selectionColor,
        display: 'inline-block',
        cursor: 'pointer'
      },
      unselect: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 30,
        height: 30,
        zIndex: 20,
        color: selectionColor,
        display: 'inline-block',
        cursor: 'pointer'
      },
      overlay: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255,255,255,0.5)',
        zIndex: 10,
        cursor: 'pointer'
      }
  })
);

interface FormItemListProps {
    path: string;
    definition: Definition;
    itemRenderer: (i: any, idx: number) => any;
    sectionConfigIcon?: any;
    suppressIconButtons?: boolean;
    emptySetRenderers?: any;
    singleRecordSelector?: string
    readOnly?: boolean;
    gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
}

// THI-901: paging clamp helper (1 of 3)
// Last valid zero-based page index for a list of `len` rows. Math.floor is wrong
// for exact multiples: 20 rows at pageSize 10 occupy pages 0 and 1, not 2 --
// which is why the two clamps this replaces are commented out below.
const lastPageFor = (len: number, pageSize: number) =>
  Math.max(0, Math.ceil(len / (pageSize || 10)) - 1)

// const FormItemList: React.FC<FormItemListProps> = ({
export const FormItemList: React.FC<FormItemListProps> = ({
    path,
    definition,
    itemRenderer,
    sectionConfigIcon,
    suppressIconButtons,
    emptySetRenderers,
    singleRecordSelector,
    readOnly,
    onChangeAtPath,
    gridSpacing,
    handleTriggerChange
}) => { 
  const classes = useStyles();

  const [fullData, setFullData] = useContext(DataContext);
  var initialDefData = getValueAtPath(path, fullData)

  // const [defData, setDefData] = useState(fullData);
  const [defData, setDefData] = useState(initialDefData || []);
  const [policyMessages, setPolicyMessages] = useContext(PolicyContext);
  const [formDirty, setFormDirty] = useContext(DirtyContext);

  const [status, setStatus] = useState("loading")
  const [currentPage, setCurrentPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [singleRecordIdx, setSingleRecordIdx] = useState(undefined)
  const [singleRecordTitle, setSingleRecordTitle] = useState(undefined)

  const getPolicyMessageClass = (policyMessage: any) => {
    switch (policyMessage.severity) {
      case 1:
        return classes.warnInstructions
      case 2:
        return classes.errorInstructions
      case 4:
        return classes.historyInstructions
      default:
        return undefined
    }
  }
  const handleItemDelete = (idx: number) => (evt: any) => {
    var newData: Array<any> = defData.filter(function (value, arrIndex) {
      return idx !== arrIndex;
    });


    // THI-901: clamp-on-delete disabled (2 of 3)
    // Superseded by the lastPage clamp effect (see THI-901 3 of 3): deleting a row
    // shrinks defData, so that effect re-clamps on the resulting render. This block
    // carried the same `maxPage &&` falsy-zero bug -- when the remaining rows fit on
    // one page maxPage is 0, the guard is false, and the clamp never ran.
    // const maxPage = Math.floor(newData.length / pageSize)
    // if (maxPage && currentPage > maxPage) {
    //
    //   setCurrentPage(maxPage)
    // }


    // check the field definitions for the _deleted field.
    // can be used to trigger a validation when a line is deleted
    var fieldDef: any
    if (definition) {
      for (let preDefined of definition.predefined) {
        if (preDefined.key == "_deleted") {
          fieldDef = preDefined
        }
      }
    }

    var pms = cloneDeep(policyMessages);
    var deepCloneData = cloneDeep(fullData)
    // filter out messages for the item that was just deleted.
    if (pms) {
        pms = policyMessages.filter((pm: any) => {
            return pm.path.indexOf(`${path}/${idx}`) == -1;
          });

        // adjust the index for other rows
        pms.forEach((pm: any) => {
            // identify remaining policy messages for the list
            if (pm.path.indexOf(`${path}/`) > -1) {
            var parts = pm.path.split("/");
            var pathIndex, partIndex;
            parts.forEach((p: string, pidx) => {
                var parsed = parseInt(p);
                // the part that is a number is the index that needs to be adjusted.
                if (!isNaN(parsed)) {
                pathIndex = parsed;
                partIndex = pidx;
                }
            });
            if (pathIndex) {
                if (pathIndex > idx) {
                pathIndex--;
                }
                parts[partIndex] = pathIndex;
                var newPath = parts.join("/");
                pm.path = newPath;
            }
            }
        });
    }

    let svpResp = setValueAtPathWithOpts(path, deepCloneData, newData, null);

    setPolicyMessages(pms)
    setFullData(svpResp.data)
    setFormDirty(true)

    if (fieldDef) {
      handleTriggerChange(path, svpResp.data, fieldDef)
    }

    evt.stopPropagation()
    evt.preventDefault()
  };

  const handleItemAdd = () => {

    var d = defData;

    // TODO: Think about being able to provide a "context" and a context form, as necessary.
    var newItem: any = { _allowsMultiplesNewEntry: true };

    d.push(newItem);

    var maxPage = Math.floor(d.length / pageSize)
    if ((d.length % pageSize) == 0) {
      maxPage--
    }

    var lastItemIDX = d.length -1

      // check the field definitions for the _append field.
      // can be used to trigger a validation when a line is added
      var fieldDef: any
      for (let preDefined of definition.predefined) {
        if (preDefined.key == "_append") {
          fieldDef = preDefined
        }
      }
    
    var deepCloneData = cloneDeep(fullData)
    let svpResp = setValueAtPathWithOpts(path, deepCloneData, d, null);

    setFullData(svpResp.data)
    setFormDirty(true)
    setCurrentPage(maxPage || 0)
    setSingleRecordIdx(lastItemIDX)
    setSingleRecordTitle("New Item")

    if (fieldDef) {
      handleTriggerChange(path, svpResp.data, fieldDef)
    }  
  };


  const renderDeleteButton = (idx: number, canDelete: boolean) => {
    if (definition.allowsMultiplesShouldConfirmDelete && !suppressIconButtons) {
      return (
        <ConfirmButton
          aria-label="delete"
          className={classes.itemDelete}
          disabled={!canDelete}
          confirmColor="danger"
          onButtonConfirm={
            canDelete
              ? handleItemDelete(idx)
              : function () { }
          }>
          <i className="fa fas fa-trash" />
        </ConfirmButton>
      )
    } else {
      if (!suppressIconButtons) {
        return (
          <IconButton
            size="small"
            aria-label="delete"
            className={classes.itemDelete}
            disabled={!canDelete}
            onClick={
              canDelete
                ? handleItemDelete(idx)
                : function () { }
            }>
            <i className="fa fas fa-trash" />
          </IconButton>
        )
      } else {
        return null
      }
    }
    

  }

  const handleItemToggle = (i: any, idx:number) => (evt: any) => {
    
    i['_selected'] = !i['_selected'];

    // Now set the state and capture the byref change above...offends my functional nature.
    var fieldDef: any
    if (definition) {
    
      for (let preDefined of definition.predefined) {
          if (preDefined.key == "_selected") {
            fieldDef = preDefined
          }
      }

      if (!fieldDef) {
        fieldDef = definition.user["_selected"]
      }

    }

    var deepCloneData = cloneDeep(fullData)

    let svpResp = setValueAtPathWithOpts(path+"/"+idx+"/_selected", deepCloneData, i['_selected'], null);

    setFullData(svpResp.data)

    if (fieldDef) {
      handleTriggerChange(path, svpResp.data, fieldDef)
    }
  };

  const handleChangePage = (newPage: number, newPageSize: number) => {
    if (pageSize != newPageSize) {
      // if the page size is changed, go back to page 1
      newPage = 0;
    }
    setCurrentPage(newPage);
    setPageSize(newPageSize||10);
    CookieManager.setCookie(
        `queryListPageSize|${window.location.pathname}`,
        String(newPageSize),
        30
      );

  };

  const findOption = (dataValue: any, keyFieldDef: any, idx: number, sectionDetails?: any): any => {
    var response = {}
    if (keyFieldDef && keyFieldDef.type) {
      if (dataValue && dataValue != "") {
        switch (keyFieldDef.type) {
          case "Text":
            if (keyFieldDef.options && keyFieldDef.options.length > 0) {
              // get the label not the value?
              for (let option of keyFieldDef.options) {
                if (dataValue && option.value == dataValue) {
                  response["label"] =  option.label,
                  response["value"] = idx
                  break
                }
                
              }
            } else {           
              if(dataValue) {
                response["label"] =  dataValue,
                response["value"] = idx
                break
              }
            }
            // options.push({label: defData[keyName], value: options.length})
            break
          default:
            console.warn("Type not supported")
            response["label"] =  "??",
            response["value"] = idx
        }

      } else {
        response["label"] =  "New Item",
        response["value"] = idx   
      }

      // See if there is a variant
      if (sectionDetails && sectionDetails[idx]) {
        response["variant"] = sectionDetails[idx]
      }
      return response
    }
  };

  const handleSingleDefChange = (attribute: string, keyField: PredefinedField, data: any) => (val: any) => {

    var subData = data[val][keyField.key]
    var option = findOption(subData, keyField, val)
    var label
    if (option.label) {
      label = option.label
    }
    setSingleRecordIdx(val)
    setSingleRecordTitle(label)

  };
  const handleSummarySelectAllClick = () => {
    var newData = defData.map((i) => {
        i['_selected'] = true;
        return i;
      });
  
      var fieldDef: any
      if (definition) {
          
          for (let preDefined of definition.predefined) {
            if (preDefined.key == "_selected") {
              fieldDef = preDefined
            }
          }
          
          if (!fieldDef) {
            fieldDef = definition.user["_selected"]
          }
      }
      var deepCloneData = cloneDeep(fullData)
      let fieldSVPResp = setValueAtPathWithOpts(path+"/"+idx+"/_selected", newData, fieldDef, null);
      newData = fieldSVPResp.data
  
      let svpResp = setValueAtPathWithOpts(path, deepCloneData, newData, null);
  
      setFullData(svpResp.data)

      if (fieldDef) {
        handleTriggerChange(path, svpResp.data, fieldDef)
      }
  };

  const handleSummaryUnselectAllClick = () => {
    
    var newData = defData.map((i) => {
      delete i['_selected'];
      return i;
    });

    var fieldDef: any
    if (definition) {
        
        for (let preDefined of definition.predefined) {
          if (preDefined.key == "_selected") {
            fieldDef = preDefined
          }
        }
        
        if (!fieldDef) {
          fieldDef = definition.user["_selected"]
        }
    }
    var deepCloneData = cloneDeep(fullData)
    let fieldSVPResp = setValueAtPathWithOpts(path+"/"+idx+"/_selected", newData, fieldDef, null);
    newData = fieldSVPResp.data

    let svpResp = setValueAtPathWithOpts(path, deepCloneData, newData, null);

    setFullData(svpResp.data)

    if (fieldDef) {
      handleTriggerChange(path, svpResp.data, fieldDef)
    }
  };

  
  // mount effect
  useEffect(() => {
    // console.log("useeffect1")
    var newData = getValueAtPath(path, fullData)
    if (!newData) {
      newData = []
    }
    var fieldDef: any
    if (definition) {
      if (definition.primedMultiples) {
        while (newData.length < definition.primedMultiples) {
          newData.push({});
        }
        for (let preDefined of definition.predefined) {
          if (preDefined.key == "_append") {
            fieldDef = preDefined
          }
        }
      }
    }
    var ps = CookieManager.getCookie(`definitionPageSize|${definition.key}`);
    if (ps != '') {
      var newPageSize = Number(ps);
      if (isNaN(newPageSize)) {
        newPageSize = 10;
      }
      setPageSize(newPageSize)
    }

    setDefData(newData);
    setStatus("ready")



    if (fieldDef) {
      handleTriggerChange(path, fullData, fieldDef)
    }
    
  }, [])

  // single dependancy on fullData
  useEffect(() => {
    var newData = getValueAtPath(path, fullData) || []
    if (definition.primedMultiples) {
      while (newData.length < definition.primedMultiples) {
        newData.push({});
      }
    }
  
    setDefData(newData);
    
  }, [fullData])

  // THI-901: page clamp on data replacement (3 of 3) -- the actual fix.
  // Outside code can replace this list's data wholesale (Terribles gl-view-fc.tsx
  // swaps every glLine on a template import, then calls setFullData). If the
  // replacement has fewer pages than the page we are parked on, every row filters
  // out of the display filter below and the list renders as an empty set even
  // though the data arrived. Clamping here follows the data down when it shrinks
  // under us, and replaces the two clamps commented out above and below.
  const lastPage = lastPageFor(defData.length, pageSize)

  useEffect(() => {
    if (currentPage > lastPage) {
      setCurrentPage(lastPage)
    }
  }, [lastPage, currentPage])


  var sectionPolicyMessages = filterPolicyMessages(policyMessages, path)


//   if (defData === null || defData === undefined) {
//     return null;
//   }


  var emptySetMessage = ""
  if (definition && definition.emptySetMesssage) {
    emptySetMessage = definition.emptySetMesssage
  }
  var instructions: Array<any> = []
  if (sectionPolicyMessages && sectionPolicyMessages.length > 0) {
    
    sectionPolicyMessages.forEach((pm: any) => {
      if (pm.path == path) {
        instructions.push(<Typography
            className={getPolicyMessageClass(pm)}
            variant="body1"
            gutterBottom
            dangerouslySetInnerHTML={{__html: pm.message}}
          />)
      }
    })
  }

//   var dataLength =  0
//   if (defData) {
//     dataLength = defData.length
//   }

  // THI-901: render-time clamp disabled (3 of 3 continued) -- this was the block
  // that was supposed to prevent the reported bug and did not. Three defects:
  //  1. `maxPage &&` is false when maxPage is 0, so the clamp was skipped in
  //     exactly the case it was written for -- replacement data that fits on a
  //     single page, which is what left the list rendering blank.
  //  2. Math.floor is off by one for exact multiples (20 rows at pageSize 10 gave
  //     maxPage 2, but page 2 is empty).
  //  3. It set state during render rather than in an effect.
  // Replaced by the lastPage clamp effect above.
  // const maxPage = Math.floor(defData.length / pageSize)
  // if (maxPage && currentPage > maxPage) {
  //   setCurrentPage(maxPage)
  // }

  let selectedItems: Array<any> = [];


  switch (status) {
    case 'loading':
      // TODO:
      return <LoadingView classes={{}} />;
      break;

    default:

      const usePaging = definition.usePaging;


      // If there are no editable fields, then we don't need to show the add button or the item delete buttons
      var hasEditableFields = false
      if (definition.predefined) {
        definition.predefined.forEach((field: PredefinedField) => {
          if(!field) {
            return;
          };

          if (field.mode == "Optional" || field.mode == "Required") {
            hasEditableFields = true
            return false
          }
        })
      }


      const items = defData.reduce(
        (acc: Array<any>, i: any, idx: number): any => {
          // Whether we display it or not, add it to the array if it is selected
          if (i['_selected'] && definition.allowSelection) {
            selectedItems.push(i);
          }
          // We are going to wrap the underlying item with controls for deletion, etc
          let includeInDisplay =
            !usePaging ||
            (idx >= currentPage * pageSize &&
              idx < currentPage * pageSize + pageSize);

    
          if (includeInDisplay) {
            var canDelete = true;

            const item = itemRenderer(i, idx);
            

            var classNames: Array<string> = [`form-list-item-${idx}`];
            var overlay: any = null;
            var selector: any = null;


            if (i['_selected'] && definition.allowSelection) {
              classNames.push(
                classes.selectedRow,
                `form-list-item-selected-row`
              );
              selector = (
                <i onClick={handleItemToggle(i, idx)} className={classes.select + ' fa fa-check-square'} />
              );
            } else {
              if (definition.allowSelection) {
                classNames.push(
                  classes.unselectedRow,
                  `form-list-item-unselected-row`
                );
                // Also put up a semi-opaque overlay as a further signal to the user.
                overlay = <div onClick={handleItemToggle(i, idx)} name="item-overlay" className={classes.overlay}></div>;
                selector = (
                  <i onClick={handleItemToggle(i, idx)} className={classes.unselect + ' fa fa-square'} />
                );
              } else {
                classNames.push(classes.unselectableRow);
              }
            }

            if (idx % 2 == 0) {
              classNames.push(classes.itemEven);
            } else {
              classNames.push(classes.itemOdd);
            }
            acc.push(
              <Grid
              style={definition.styleAttributes?.backgroundColor ? {backgroundColor: definition.styleAttributes?.backgroundColor || ''} : {}}
                key={idx}
                className={
                  classes.item +
                  ' ' +
                  classNames.join(' ') +
                  ' ' +
                  `${definition.key}${idx}`
                }
                data-row-index={idx}
                data-section-key={definition.key}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}>
                <div name="item-display-area" style={{ width: "100%", display: 'flex' }}>
                  {item}
                  {!readOnly && renderDeleteButton(idx, hasEditableFields && !i["_preventDelete"] && (!definition.allowsMultiplesPreventDelete || i["_allowsMultiplesNewEntry"]))}
                  {overlay}
                  {selector}
                </div>
              </Grid>
            );
          }
          return acc;
        },
        []
      );


      let actionBar: any = null;
      if (
        (!definition.maxCount || defData.length < definition.maxCount)
      ) {
        var actionClass
        if (singleRecordSelector){
          actionClass = classes.singleItemActionBar
        } else {
          actionClass = classes.itemActionBar
        }

        if (!suppressIconButtons) {
          actionBar = (
            <Grid
              key={'action-bar'}
              className={actionClass}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}>
              <IconButton
                size="large"
                aria-label="add"
                disabled={!hasEditableFields}
                className={classes.itemAdd}
                style={{marginTop: 7}}
                onClick={handleItemAdd}>
                <i title={definition.title || "Add Item"} className="fa fas fa-plus-circle" />
              </IconButton>
            </Grid>
          );
        }
      }

      var emptySet = (
        <EmptySet style={{ color: 'red' }} text={emptySetMessage || "No items have been added"} />
        // <EmptySet classes={{}} text= "No items have been added" />
      );
      if (
        emptySetRenderers &&
        definition.emptySetRenderer &&
        emptySetRenderers[definition.emptySetRenderer]
      ) {
        emptySet = emptySetRenderers[definition.emptySetRenderer]();
      }

      var pager = null;

      if (usePaging && defData.length > 0) {
        
        var pageSizeOptions
        if (definition.pageSizeOptions) {
          pageSizeOptions = definition.pageSizeOptions
        }

        pager = (
          <div className={classes.pagerArea}>
            <div className={classes.pager}>
              <Pager
                page={currentPage}
                pageSize={pageSize || 10}
                count={defData.length || 0}
                onChangePage={handleChangePage}
                pageSizeOptions={pageSizeOptions}
              />
            </div>
          </div>
        );
      }

      let singleRecord: any = null;
      if (singleRecordSelector && singleRecordSelector != "") {
        // Get the title based on the selector
        var _fd = definition.predefined.find((p)=>{
          return p.key = singleRecordSelector
        })
        var title:string = " ";
        var selectorText:string = "Select a Record"
        if (_fd && _fd.title){
          title = `Select the ${_fd.title} to display.`
          selectorText = `-- ${_fd.title} --`
        }
        var constructedField = new PredefinedField({})
        constructedField.mode = "Optional"
        constructedField.key = "derivedOptions"
        constructedField.gridAttributes = {
          "xl": 3,
          "lg": 3,
          "md": 4,
          "sm": 6,
          "xs": 12,
        }
        constructedField.title = title
        constructedField.type = "Text"
        constructedField.placeholder = "Select an item"
        constructedField.nullOptionLabel = selectorText



        var pathExt = path + '/';

        var sectionDetails = {}
        if (policyMessages && policyMessages.length > 0) {
          let duplicate = false
          const applicable = policyMessages.reduce((acc, m): Array<any> => {
            let mp = m.path;
            if (mp.indexOf('/') == 0) {
              mp = mp.substring(1);
            }

            let op = path;
            if (op.indexOf('/') == 0) {
              op = op.substring(1);
            }
            // includes instead of equals here, becuase we are looking for sub-messages. 
            if (mp.includes(op)) {
              acc.push(m);
            }

            var secIdx = m.path
            if (m.path.indexOf(pathExt) == 0) {
             secIdx = m.path.replace(pathExt, '');
             if (secIdx.indexOf('/') != -1) {
              // trying to set sectionDetails[idx], 
              // finding idx by grabbing the substring after pathExt, but before the next slash, which should then be a number to be parsed. 
              sectionDetails[parseInt(secIdx.substring(0, secIdx.indexOf('/')))] = "error"
             }
            }

            if (m.path == pathExt + constructedField.key) {
              duplicate = true
            }
    
            return acc;
          }, []);
            
          if (!duplicate) {
            policyMessages.push({
              message: "One or More Records have Errors",
              path: pathExt + constructedField.key,
              severity: 2,
              title: "One or More Records have Errors",
            })
          
          }
        }
        
        // Move to line 1291
        
        var options = []
        var idx = 0
        var keyName = definition.singleRecordSelector

        var keyFieldDef 
        if (definition.predefined) {
          // find the def of the key field, for the mode and options. 
          for (let field of definition.predefined) {
            if (field.key && field.key == definition.singleRecordSelector) {
              keyFieldDef = field
            }
          }
        }
        if (defData) {
          // if (data[definition.key]) {
            for (let subDefData of defData) {
              options.push(findOption(subDefData[keyName], keyFieldDef, idx, sectionDetails))
              idx++
            }
          // }
          constructedField.options = options

          // End move line

        }
        const fr = (
          // <div style={{ position: 'relative', width: '100%' }}>
            <Grid
            spacing={gridSpacing || 1}
            className={classes.formAreaOutdent}
            container>
            
          
              <Grid key={'grid_item_' + idx} spacing={1} item xl={3} lg={3} md={4} sm={6} xs={12}>
              <Field
                path={constructedField.path || (pathExt + constructedField.key)}
                // value={val}
                className={classes.fieldArea}
                fieldDefinition={constructedField}
                onCommitChange={handleSingleDefChange((constructedField.path || constructedField.key), keyFieldDef, defData)}
                // customRenderers={this.props.customRenderers}
                policyMessages={policyMessages}
                // readOnly={this.props.readOnly}
                // onAccessRootData={this.props.onAccessRootData}
              />
              
              </Grid>
              <Grid
                key={"addNewSingleItem"}
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                xl={3}>
                <div className={classes.formArea}>
                  {!readOnly && hasEditableFields && actionBar}
                </div>
              </Grid>
            </Grid>
          // </div>
        );

        const item = itemRenderer(defData[singleRecordIdx], singleRecordIdx);

        singleRecord =  (
          <Grid key={'grid_item_' + singleRecordIdx} item xl={definition.gridAttributes.xl || 12} lg={definition.gridAttributes.lg || 12} md={definition.gridAttributes.md || 12} sm={definition.gridAttributes.sm || 12} xs={definition.gridAttributes.xs || 12} className={classes.formAreaOutdent}>
          <div style={definition.styleAttributes} >
            {definition.instructions && <FormHelperText><div dangerouslySetInnerHTML={{ __html: definition.instructions }}></div></FormHelperText>}
            {fr}
            <Typography variant="h2" className={classes.subSectionTitle}>
              {singleRecordTitle}
            </Typography>
            {item}
            </div>
          </Grid>
        );
      }




      if (definition.allowSelection && defData.length > 0) {
        // This section uses a switch, since I started using the word `items` in there, so wanted to be able to have appropraite grammar and ploralization.
        var selectionActionArea: any = null;
        var selectionCountText: string = ""
        switch (selectedItems.length) {
          case 0:
            selectionCountText = "(0 of " + defData.length + " selected)"
            break;

          case 1:
            selectionCountText = "(1 of " + defData.length + " selected)"
            break;

          default:
            selectionCountText = "(" + selectedItems.length + " of " + defData.length + " selected)"
        }

        selectionActionArea = (
          <div className={classes.selectionActionArea}>
            <div className={classes.allSelectors}>
              <div className={classes.selectAll} onClick={handleSummarySelectAllClick} >
                <i className={"fa fa-check-square " + classes.selector} /> Select All
              </div>
              <div className={classes.unselectAll} onClick={handleSummaryUnselectAllClick} >
                <i className={"fa fa-square " + classes.selector} /> Unselect All
              </div>
            </div>
            <div className={classes.selectionCount}>
              {selectionCountText}
            </div>
          </div>
        )
      }
      
      classes.instructions
      var instructionClass = classes.instructions
      if (!instructions || instructions.length == 0) {
        instructionClass = classes.noInstructions
      }
      return (
        <div className={classes.container + ' ' + definition.key}>
          <div className={instructionClass}>
            {instructions}
          </div>
          <Grid spacing={gridSpacing || 1} container className={classes.gridContainerOffset}>
            <div
              style={{ width: "100%" }}
              className="item-list-paging-container">
              {selectionActionArea}
              {!singleRecordSelector && items.length > 0  && items}
              {singleRecordSelector != "" && singleRecord}
              {items.length == 0 && emptySet}
              {pager}
            </div>
          </Grid>
          {!readOnly && !singleRecordSelector && actionBar}
        </div>
      );
  }
};

export default FormItemList;